module.exports = __webpack_public_path__ + "static/media/iso-icon.25111eba.png";